import React, { useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router";
import { addcategory } from "../../services/Mainservice";
import { Snackbar } from "../../utils/snackbar";

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Required";
  }

  return errors;
};

const Addcategory = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");

  const navigate = useNavigate();
  const handleClose = (event, reason) => {
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await addcategory(values.name);
      navigate("/Category_List");
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add Category</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Category Name</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="name"
              type="text"
              placeholder="Catgeory Name"
              minLength={1}
              maxLength={200}
              //   value={data.name}
              className="Auth_input"
            />
            {formik.errors.name ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>

          <div />
          <button className="term_button" type="Submit">
            {load ? "Adding..." : "Save"}
          </button>
        </form>
      </div>
      <Snackbar
        open={open}
        severity="error"
        onclose={handleClose}
        message={err}
      />
    </>
  );
};
export default Addcategory;
